import http from '../../../lib/http';
import {prepareRegisterItemsToRequest} from '../../../lib/util';

export const FETCH_HABITUE_DETAIL_START = 'FETCH_HABITUE_DETAIL_START';
export const FETCH_HABITUE_DETAIL_ERROR = 'FETCH_HABITUE_DETAIL_ERROR';
export const FETCH_HABITUE_DETAIL_SUCCESS = 'FETCH_HABITUE_DETAIL_SUCCESS';

export const FETCH_HABITUE_BIlLS_TO_PAY_START = 'FETCH_HABITUE_BIlLS_TO_PAY_START';
export const FETCH_HABITUE_BIlLS_TO_PAY_ERROR = 'FETCH_HABITUE_BIlLS_TO_PAY_ERROR';
export const FETCH_HABITUE_BIlLS_TO_PAY_SUCCESS = 'FETCH_HABITUE_BIlLS_TO_PAY_SUCCESS';

export const FETCH_PAY_DEBT_START = 'FETCH_PAY_DEBT_START';
export const FETCH_PAY_DEBT_ERROR = 'FETCH_PAY_DEBT_ERROR';
export const FETCH_PAY_DEBT_SUCCESS = 'FETCH_PAY_DEBT_SUCCESS';

export const CLEAR_HABITUE_DETAIL = 'CLEAR_HABITUE_DETAIL';
export const CHOOSE_HABITUE_DETAIL = 'CHOOSE_HABITUE_DETAIL';
export const SHOW_DETAIL_DEBT_ITEMS = 'SHOW_DETAIL_DEBT_ITEMS';
export const SET_DEBT_TO_PRINT = 'SET_DEBT_TO_PRINT';
export const COOSE_DEBT_TO_PAY = 'COOSE_DEBT_TO_PAY';
export const TOGGLE_BILL_CHECKBOX = 'TOGGLE_BILL_CHECKBOX';
export const CLEAR_BILL_CHECKBOX = 'CLEAR_BILL_CHECKBOX';

export function toggleBillCheckbox(id, price) {
    return {
        type: TOGGLE_BILL_CHECKBOX,
        payload: {id, price}
    }
}
export function setDebtToPrint(bill) {
    return {
        type: SET_DEBT_TO_PRINT,
        payload: {bill}
    }
}

export function clearBillCheckbox() {
    return {
        type: CLEAR_BILL_CHECKBOX
    }
}

export function clearHabitueDetail() {
    return {
        type: CLEAR_HABITUE_DETAIL
    }
}

export function chooseDebtToPay(id) {
    return {
        type: COOSE_DEBT_TO_PAY,
        payload: {id}
    }
}

export function chooseHabitueDetail(id) {
    return {
        type: CHOOSE_HABITUE_DETAIL,
        payload: {id}
    }
}

export function showDetailDebtItems(id) {
    return {
        type: SHOW_DETAIL_DEBT_ITEMS,
        payload: {id}
    }
}

export function fetchPayDebt(data) {
    return {
        type: 'FETCH_PAY_DEBT',
        payload: {
            promise: postPayDebt(data)
        }
    };
}

export function fetchHabitueBillsToPay(debtId, billsIds) {
    return {
        type: 'FETCH_HABITUE_BIlLS_TO_PAY',
        payload: {
            promise: getHabitueBillsToPay(debtId, billsIds)
        }
    };
}

export function fetchHabitueDetail(debtId, limit, page) {
    return {
        type: 'FETCH_HABITUE_DETAIL',
        payload: {
            promise: getHabitueDetail(debtId, limit, page)
        }
    };
}

async function getHabitueDetail(debtId, limit, page) {
    const res = await http.get(`/app/bills/habitue-detail/${debtId}/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function getHabitueBillsToPay(debtId, billsIds) {
    const res = await http.post(`/app/bills/all-unpaid-habitue-bills`, {body: {debtId, billsIds}});
    if (res.status < 300) return res.json();
    throw res;
}

async function postPayDebt(data) {
    const res = await http.post(`/app/bills/pay-bills`, {
        query: {
            c: data.cashboxId,
            b: data.barId,
            br: data.branchId,
            d: data.discount,
            pt: data.paymentType,
            did: data.deviceId,
            number: data.number,
            selltime: data.sellTime.toISOString()
        },
        body: {
            billsIds: data.ids,
            items: prepareRegisterItemsToRequest(data.items, data.discount)
        }
    });
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/menu/credit/debtDetail/actions.js